export interface IMailing {
  name: string;
  email: string;
  message: string;
  captcha: string;
}

export class MailingClass implements IMailing {
  name: string;
  email: string;
  message: string;
  captcha: string;

  constructor(mailing?: Partial<IMailing>) {
    this.name = mailing?.name ?? '';
    this.email = mailing?.email ?? '';
    this.message = mailing?.message ?? '';
    this.captcha = mailing?.captcha ?? '';
  }
}
